<template>
	<div class="item-icon close-button-container">
		<BaseIcon
			class="modal-close-button"
			icon="close"
			type="standard"
			:isCustom="true"
			@click="closeButton()"
			ariaLabel="close modal dialog"/>
	</div>
</template>

<script>
	import navigationMixin from '@Mixin/navigationMixin';
	export default {
		mixins: [navigationMixin],
		methods: {
			closeButton() {
				this._navigateBack();
			},
		},
	}
</script>

<style lang="scss" scoped>
	@import '@style-vars';
	@import 'commonStyle/nav-item';
	@include mobile {}
	@include desktop {}
	@include tablet {}
</style>


// WEBPACK FOOTER //
// src/components/header/NavigationItems/CloseButton.vue